import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { getErrorHttpMessage } from "utils";
import { getBitacoraCotizacionHttp } from "actions/cotizacion";
import type {
    BitacoraCotizacionItem,
    BitacoraCotizacionRespuesta,
} from "../types/bitacoraCotizacion.types";

export const useBitacoraCotizacion = (id_cotizacion: number | string | null | undefined) => {
    const intl = useIntl();

    const [procesando, setProcesando] = useState<boolean>(false);
    const [bitacora, setBitacora] = useState<BitacoraCotizacionItem[]>([]);
    const [folioRequisicion, setFolioRequisicion] = useState<string | null>(null);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [mensajeAlert, setMensajeAlert] = useState("");
    const handleisAlertOpen = () => setIsAlertOpen(true);
    const handleisAlertClose = () => setIsAlertOpen(false);

    const limpiar = () => {
        setBitacora([]);
        setFolioRequisicion(null);
    };

    const getBitacoraCotizacion = useCallback(async (idCotizacion: number | string) => {
        try {
            setProcesando(true);
            const response = (await getBitacoraCotizacionHttp(Number(idCotizacion))) as
                | BitacoraCotizacionRespuesta
                | BitacoraCotizacionItem[];

            if (Array.isArray(response)) {
                setBitacora(response);
                setFolioRequisicion(null);
            } else {
                setBitacora(response?.eventos ?? []);
                setFolioRequisicion(response?.folio_requisicion ?? null);
            }
        } catch (error) {
            limpiar();
            const message = getErrorHttpMessage(error);
            setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
            handleisAlertOpen();
        } finally {
            setProcesando(false);
        }
    }, []);

    useEffect(() => {
        if (id_cotizacion) {
            getBitacoraCotizacion(id_cotizacion);
        } else {
            limpiar();
        }
    }, [id_cotizacion]);

    return {
        intl,
        procesando,
        bitacora,
        folioRequisicion,
        isAlertOpen,
        mensajeAlert,
        handleisAlertClose,
        getBitacoraCotizacion,
    };
};